import cn from 'classnames'
import Button from 'ext-ui/components/Button/Button'
import React from 'react'
import { useSelector } from 'react-redux'
import BrandPrimaryLogo from 'src/components/BrandPrimaryLogo/BrandPrimaryLogo'
import Popup from 'src/components/Popup/Popup'
import SvgBmoCobrandWhatsNew from 'src/components/Svgs/SvgBmoCobrandWhatsNew'
import SvgPncExtendCobrand from 'src/components/Svgs/SvgPncExtendCobrand'
import { CoBrands } from 'src/enums'
import { useFlyoutDispatch } from 'src/hooks'
import { useTranslate } from 'src/localization/Trns'
import { useQueryBrandRedirectSuggestions } from 'src/queries/auth.queries'
import { createSetIsBrandRedirectPopupOpen } from 'src/redux/actions/app.actions'
import { createSetPerSessionValues } from 'src/redux/actions/auth.actions'
import { selectAppName } from 'src/redux/selectors/session.selectors'

import style from './BrandRedirectPopup.style'

const BrandRedirectPopup: React.FC = () => {
  const dispatch = useFlyoutDispatch()
  const appName = useSelector(selectAppName)
  const translate = useTranslate()

  const { data: brandRedirectSuggestions } = useQueryBrandRedirectSuggestions()

  const cobrandSvg = (brand: string): React.ReactElement | undefined => {
    switch (brand as unknown as CoBrands) {
      case CoBrands.Pnc:
        return <SvgPncExtendCobrand />
      case CoBrands.Bmo:
        return <SvgBmoCobrandWhatsNew />
      default:
        return undefined
    }
  }

  const closeModal = (): void => {
    dispatch(createSetPerSessionValues({
      isBrandSuggestionPopupDismissed: true,
    }))
    dispatch(createSetIsBrandRedirectPopupOpen(false))
  }

  return (
    <Popup
      onClose={closeModal}
      css={style}
    >
      <div className={cn('BrandRedirectPopup-title')}>
        {translate('Continue with ${appName}?', { appName })}
      </div>
      <div className={cn('BrandRedirectPopup-body')}>
        <span>
          {translate('You\'re currently using ${appName}. According to your settings, one of our other apps listed below may be a better fit. Would you like to switch?', { appName })}
        </span>
      </div>
      <ul className={cn('BrandRedirectPopup-suggestionList')}>
        {Object.values(brandRedirectSuggestions || []).map((brand, i) => {
          const brandName = brand.slug
          return <li key={i}>
            <a
              data-testid={`${brandName}-redirect-link`}
              aria-label={translate('Go to ${brandName}', { brandName: brand.name })}
              href={brand.host}
              className={cn('BrandRedirectPopup-suggestionList-link', brandName)}
            >
              {cobrandSvg(brandName)
                ? cobrandSvg(brandName)
                : <BrandPrimaryLogo key={brandName} brand={brandName} />
              }
            </a>
          </li>
        })}
      </ul>
      <div>
        <Button
          data-testid={'continueBtn'}
          dropShadow={false}
          onClick={closeModal}
        >
          {translate('No, continue with ${appName}', { appName })}
        </Button>
      </div>
    </Popup>
  )
}

export default BrandRedirectPopup
